import { EElement, EElementGroup, ELogicalElement } from '@progress-fe/core';
export const ElementGroupIcon = {
    [EElementGroup.FlowsGroup]: 'MaterialFlow',
    [EElementGroup.HeatTransferGroup]: 'Cooler',
    [EElementGroup.PressureChangeGroup]: 'Compressor',
    [EElementGroup.PipelineGroup]: 'Mixer',
    [EElementGroup.CapacitiveDevicesGroup]: 'Separator_2ph',
    [EElementGroup.ColumnDevicesGroup]: 'Fractionator',
    [EElementGroup.ReactorDevicesGroup]: 'ConversionReactor',
    [EElementGroup.CatalyticProcessesGroup]: 'CatCracking',
    [EElementGroup.HydroProcessesGroup]: 'DieselFuelHydrotreating',
    [EElementGroup.ThermalProcessesGroup]: 'Coker',
    [EElementGroup.SyntheticElementsGroup]: 'Synthetic',
    [EElementGroup.DebugGroup]: 'MaterialFlow'
};
export const ElementIcon = {
    [EElement.AbsorberElement]: 'Absorber',
    [EElement.MaterialFlowElement]: 'MaterialFlow',
    [EElement.EnergyFlowElement]: 'EnergyFlow',
    [EElement.TwoPhaseSeparatorElement]: 'Separator_2ph',
    [EElement.ThreePhaseSeparatorElement]: 'Separator_3ph',
    [EElement.CompressorElement]: 'Compressor',
    [EElement.CatCrackingElement]: 'CatCracking',
    [EElement.CatCrackingReactorRegeneratorBlockElement]: 'CatCrackingRRBlock',
    [EElement.CatReformingElement]: 'CatReforming',
    [EElement.CatReformingReactorBlockElement]: 'CatReformingRRBlock',
    [EElement.DieselFuelHydrotreatingElement]: 'DieselFuelHydrotreating',
    [EElement.DieselFuelHydrotreatingReactorBlockElement]: 'DieselFuelHydrotreatingRBlock',
    [EElement.DistillationColumnWithReboilerAndCapacitorElement]: 'DistillationColumnRC',
    [EElement.CokerElement]: 'Coker',
    [EElement.CokerReactorBlockElement]: 'Coker',
    [EElement.CoolerElement]: 'Cooler',
    [EElement.ValveElement]: 'Valve',
    [EElement.HeaterElement]: 'Heater',
    [EElement.HeatExchangerElement]: 'HeatExchanger',
    [EElement.PumpElement]: 'Pump',
    [EElement.MixerElement]: 'Mixer',
    [EElement.PipelineElement]: 'Pipeline',
    [EElement.FractionatorElement]: 'Fractionator',
    [EElement.DetanderElement]: 'Detander',
    [EElement.SplitterElement]: 'Splitter',
    [EElement.ComponentSplitterElement]: 'ComponentSplitter',
    [EElement.ConversionReactorElement]: 'ConversionReactor',
    [EElement.EquilibriumReactorElement]: 'EquilibriumReactor',
    [EElement.WaterJetPumpElement]: 'WaterJetPump',
    [EElement.HeatExchangerSynthetic]: 'Synthetic', // Синтетический
    [EElement.MultiStepCoherent]: 'Synthetic', // Синтетический
    [EElement.MultiStepExternal]: 'Synthetic', // Синтетический
    [EElement.Balancer]: 'Synthetic', // Синтетический
    [EElement.EngineTestSynthetic]: 'Synthetic', // Синтетический
    [EElement.SingleParamChangeElement]: null
};
export const LogicalElementIcon = {
    [ELogicalElement.Recycle]: 'Recycle',
    [ELogicalElement.Function]: 'Function',
    [ELogicalElement.Optimization]: 'Optimization',
    [ELogicalElement.Cutter]: null,
    [ELogicalElement.Set]: null
};
//# sourceMappingURL=icon.constant.js.map